/*
 * @Description: 免费版弹窗
 * @Author: ywj
 * @Date: 2025-08-06 10:09:46
 * @LastEditTime: 2025-08-06 17:37:05
 * @LastEditors: taoyuan taoyuan@originqc.com
 */
'use client';
import React, { useState, useEffect } from 'react';
import { Modal, Button, message } from 'antd';
import { getPdfContent } from '@/api/personal-center';
import './index.scss';

interface IFreeProps {
  freeVisible: boolean;
  setFreeVisible: (freeVisible: boolean) => void;
  sdkLink: string | null; //sdk下载链接
}
const FreeModal: React.FC<IFreeProps> = ({
  freeVisible,
  setFreeVisible,
  sdkLink,
}) => {
  const [isDisabled, setIsDisabled] = useState(true);
  const [pdfLink, setPdfLink] = useState<string | null>(null);
  const [time, setTime] = useState(5);

  useEffect(() => {
    handleAgreement();
  }, []);

  useEffect(() => {
    let timer: NodeJS.Timeout | null = null;
    if (freeVisible && isDisabled) {
      timer = setInterval(() => {
        setTime((time) => time - 1);
      }, 1000);
      if (time <= 0) {
        clearInterval(timer);
        setIsDisabled((isDisabled) => !isDisabled);
      }
    }
    // 清理函数，在组件卸载或依赖项变化时执行
    return () => {
      if (timer) {
        clearInterval(timer);
      }
    };
  }, [freeVisible, isDisabled, time]);

  // 监听 freeVisible 变化，关闭时重置状态
  useEffect(() => {
    if (!freeVisible) {
      setIsDisabled(true);
      setTime(5);
    }
  }, [freeVisible]);
  
  const handleCancel = () => {
    setFreeVisible(false);
  };

  const handleAgreement = () => {
    getPdfContent().then((res: any) => {
      if (res.success) {
        setPdfLink(res.obj?.license);
      } else {
        message.error(res.message);
      }
    });
  };
  const handleDownloadSdk = () => {
    if (sdkLink) {
      window.location.href = sdkLink;
    }
  };

  return (
    <Modal
      width={600}
      centered
      // destroyOnHidden={true}
      maskClosable={false}
      closable={false}
      title={null}
      open={freeVisible}
      onCancel={handleCancel}
      className='free-modal'
      footer={[
        <>
          <Button
            type='primary'
            disabled={isDisabled}
            onClick={handleDownloadSdk}
          >
            我已阅读并同意{isDisabled && <span>({time}s)</span>}
          </Button>
          <Button onClick={handleCancel}>取消</Button>
        </>,
      ]}
    >
      <div className='content'>
        <embed
          src={pdfLink + '#toolbar=0'}
          type='application/pdf'
          width='100%'
          height='100%'
        />
      </div>
    </Modal>
  );
};

export default FreeModal;
